export const camelCaseToSpace = (value: string) => {
  return value.replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/^./, (str: string) => str.toUpperCase())
}
